import * as React from 'react';
import {Certification} from '../../../../store/projects/commonTypes';
import {User} from 'oidc-client';
import SecurableDownloadLink from "../../../application/SecurableDownloadLink";
import {Download} from "@mui/icons-material";
import {certificationStatusOptions, getOptionLabel} from "../../../../utils/utils";

export interface AssessmentDetailsProps {
    certification: Certification;
    user: User;
    showError: (error) => void;
}

export default class AssessmentDetails extends React.Component<AssessmentDetailsProps> {

    public render() {
        return (
            <React.Fragment>
                <div className="details">
                    <div className="row">
                        <div className="col-sm-12 mb-4">
                            <div>
                                <span className="label">Revisjonsfase</span>
                            </div>
                            <div>
                                <span className="data-value">{this.props.certification.phase}</span>
                            </div>
                        </div>
                        {this.props.certification.project?.projectNumber && (
                        <div className="col-sm-12 mb-4">
                            <div>
                                <span className="label">ProsjektID</span>
                            </div>
                            <div>
                                <span className="data-value">{this.props.certification.project?.projectNumber}</span>
                            </div>
                        </div>
                        )}
                        <div className="col-sm-12 mb-4">
                            <div>
                                <span className="label">Prosjekt</span>
                            </div>
                            <div>
                                <span className="data-value">{this.props.certification.project?.name}</span>
                            </div>
                        </div>
                        {this.props.certification.certificationLevelResult && (
                            <div className="col-sm-12 mb-4">
                                <div>
                                    <span className="label">Serifiseringsnivå resultat</span>
                                </div>
                                <div>
                                    <span
                                        className="data-value">{this.props.certification.certificationLevelResult}</span>
                                </div>
                            </div>
                        )}
                        {this.props.certification.certificationScoreResult && (
                            <div className="col-sm-12 mb-4">
                                <div>
                                    <span className="label">Oppnådde poeng</span>
                                </div>
                                <div>
                                    <span
                                        className="data-value">{this.props.certification.certificationScoreResult}</span>
                                </div>
                            </div>
                        )}
                        <div className="col-sm-12 mb-4">
                            <div>
                                <span className="label">Status</span>
                            </div>
                            <div>
                                <span className="data-value">{getOptionLabel(certificationStatusOptions, this.props.certification.certificationStatus)}</span>
                            </div>
                        </div>
                        {(this.props.certification.certificationInternalLink) && (
                            <div className="col-sm-12 mb-4">
                                <div>
                                    <span className="label">Sertifikat</span>
                                </div>
                                <div>
                                    <span className="data-value"><SecurableDownloadLink user={this.props.user}
                                                                                        showError={error => this.props.showError(error)}
                                                                                        path={`/api/certification/${this.props.certification.id}/certificate`}><Download/> Last ned</SecurableDownloadLink></span>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}